import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigureServiceErrorComponent} from './configure-service-error.component';
import {I18nModule} from '@spartacus/core';
import {NgDesignSystemModule} from 'ng-design-system';
import {ContactCtaModule} from '@app/contact-cta/contact-cta.module';
import {GenericConfiguratorErrorModule} from '../generic-configurator-error/generic-configurator-error.module';
import {NetNewModule} from '../net-new/net-new.module';
import {DefaultConfiguratorErrorModule} from '../default-configurator-error/default-configurator-error.module';

@NgModule({
  declarations: [
    ConfigureServiceErrorComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    NgDesignSystemModule,
    ContactCtaModule,
    GenericConfiguratorErrorModule,
    DefaultConfiguratorErrorModule,
    NetNewModule
  ],
  exports: [
    ConfigureServiceErrorComponent
  ]
})
export class ConfigureServiceErrorModule {
}
